/* Modulo: Hero Kinetic — rotating-headline animation. Vanilla, reduced-motion safe. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'transform .62s cubic-bezier(.7,0,.2,1)';

  function initRotator(track, interval) {
    if (track.dataset.hkRotInit === '1') return;
    var words = track.children.length - 1; // last child duplicates the first for a seamless loop
    if (words < 2) return;
    track.dataset.hkRotInit = '1';

    var i = 0;
    function lineH() { return track.children[0].getBoundingClientRect().height || 0; }

    track._hkTimer = setInterval(function () {
      if (document.hidden) return;
      i++;
      track.style.transition = EASE;
      track.style.transform = 'translateY(' + (-i * lineH()) + 'px)';
      if (i >= words) {
        track._hkSnapTimer = setTimeout(function () {
          track.style.transition = 'none';
          i = 0;
          track.style.transform = 'translateY(0)';
        }, 640);
      }
    }, interval);
  }

  function initSection(el) {
    if (el.dataset.moduloHkInit === '1') return;
    el.dataset.moduloHkInit = '1';
    if (REDUCE) return; // first word stays visible (overflow-clipped)
    var interval = parseInt(el.getAttribute('data-hk-interval'), 10) || 2200;
    var rots = el.querySelectorAll('[data-hk-rot]');
    for (var i = 0; i < rots.length; i++) {
      var track = rots[i].querySelector('.modulo-hk__rot-track');
      if (track) initRotator(track, interval);
    }
  }

  function teardownSection(el) {
    var rots = el.querySelectorAll('[data-hk-rot]');
    for (var i = 0; i < rots.length; i++) {
      var track = rots[i].querySelector('.modulo-hk__rot-track');
      if (track && track._hkTimer) {
        clearInterval(track._hkTimer);
        track._hkTimer = null;
        if (track._hkSnapTimer) { clearTimeout(track._hkSnapTimer); track._hkSnapTimer = null; }
        track.dataset.hkRotInit = '';
        track.style.transition = 'none';
        track.style.transform = 'translateY(0)';
      }
    }
    el.dataset.moduloHkInit = '';
  }

  function initAll() {
    var els = document.querySelectorAll('[data-modulo-hk]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-modulo-hk]') : null;
    if (el) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-modulo-hk]') : null;
    if (el) teardownSection(el);
  });
})();
